<template>
  <div>
    <div>
      <modal name="welcome">
          <button class="m-1" style="float:right; background:none;border:none;" @click="$modal.hide('welcome')">
            ❌
          </button>
          <h3 class="mt-5 ml-5">Welcome to Anyword</h3>
          <p class="m-5">Hello There!, I'm so excited about you and everyone who visit this website. 
            Please write anything and anyword you want. It can be a Motivation, Quote from someone or 
            maybe from you, or anthing. I'm so happy to ready it here. <b>Share it to Others</b></p>
      </modal>
    </div>
    <modal name="msgModal" height="auto">
      <button class="m-1" style="float:right; background:none;border:none;" @click="$modal.hide('msgModal')">
        ❌
      </button>
      <MyModal 
        :msgTitle="getMessage.username"
        :msgImg="getMessage.imgURL"
        :msgDate="getMessage.date"
        :msgMsg="getMessage.message"
        :msgNumb="getMessage.number"
      />
    </modal>
    <modal name="apiModal" height="auto" >
      <button class="m-1" style="float:right; background:none;border:none;" @click="$modal.hide('apiModal')">
        ❌
      </button>
      <ApiDoc />
    </modal>
    <modal name="aboutModal" height="auto">
      <button class="m-1" style="float:right; background:none;border:none;" @click="$modal.hide('aboutModal')">
        ❌
      </button>
      <About />
    </modal>
    <h1 class="mt-5" style="text-align:center;">Anyword</h1>
    <hr>
    <center>
      <a class="text-info" href="#" @click="showAPIDoc">API Doc</a>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      <a class="text-info" href="#" @click="showAbout">About</a>
    </center>
    <center>
      <button @click="showMessageForm = !showMessageForm" type="submit" class="btn btn-outline-info my-5">Say Something</button>
    </center>
    <div class="col-m-12">
      <div class="col-m-3">&nbsp;</div>
      <div class="col-m-6">
        <form v-if="showMessageForm" @submit.prevent="addMessage" class="mb-5">
          <div v-if="error" class="alert alert-dismissible alert-danger">
            <strong>Error!</strong> {{error}}
          </div>
          <div class="form-group">
            <label for="username">Name</label>
            <input v-model="message.username" type="text" 
            class="form-control" id="username" value="Anonymous" required>
          </div>
          <div class="form-group">
            <label for="text">Message</label>
            <textarea v-model="message.message" 
            class="form-control" id="message" 
            rows="3" required></textarea>
          </div>
          <button type="submit" class="btn btn-outline-success float-right">Send My Words</button>
        </form>
      </div>
      <div class="col-m-3">&nbsp;</div>
    </div>
    <div class="row">
      <div class="card col-md-3 mb-3" id="card-container" style="width:100%;" v-for="message in reversedMsg" :key="message._id">
        <div class="card-body" @click="showMsgModal(message.number)">
          <center>
            <h4 class="card-title text-dark">{{message.username}}</h4>
            <img style="height: 75px; width: 75px; display: block; border-radius:100px; border:1.5px solid #000000;" class="mb-4" :src="'/images/'+ message.imgURL + '.svg'" :alt="message.Title">
            <h6 class="card-subtitle mb-2 text-muted" style="margin-top:-12px; font-size:10pt;">{{message.date}}</h6>
            <p class="card-text text-dark mt-3">"{{message.message}}"</p>
          </center>
        </div>
      </div>
      <div class="col-md-12 mt-5">
        <center>
          <button class="btn btn-outline-secondary" @click="loadWords">Load More</button>
        </center>
      </div>
    </div>
  </div>
</template>

<style scoped>
  hr{
    border : 1px solid white;
  }
  img{
    width:100px;
    height: auto;
  }
  #card-container{
    opacity:0;
    transition: 1s
  }
  #card-container.card{
    opacity:1; 
  }
  .card{
    transition: 0.5s;
  }
  .card:hover{
    cursor: pointer;
    background-color:rgb(211, 211, 211);
  }
</style>

<script>

import MyModal from '../components/myModal';
import ApiDoc from './api';
import About from './about';
var limitMsg = 4;
const urlAPIGet = 'https://young-brook-59453.herokuapp.com/all-messages-from-server/'+limitMsg;
const urlAPIPost = 'https://young-brook-59453.herokuapp.com/all-messages-from-server/';
const months = ["January", "February", "March","April", "May", "June", "July", "August", "Sptember", "October", "November", "December"];
var current_datetime = new Date();

export default {
  components:{
    MyModal,
    ApiDoc,
    About
  },
  name: 'home',
  data: () => ({
    limitMessages: limitMsg,
    showMessageForm: false,
    error: '',
    messages: [],
    message: {
      username: 'Anonymous',
      message: '',
      imgURL: Math.floor(Math.random() * (6 - 1) + 1),
      date: current_datetime.getDate() + "-" + months[current_datetime.getMonth()] + "-" + current_datetime.getFullYear(),
      number: 0
    },
    getMessage: '',
  }),
  mounted() {
    fetch(urlAPIGet).then(res => res.json()).then((result) => {
        this.messages = result;
    });
    this.show();
  },
  computed: {
    reversedMsg() {
      return this.messages.slice().reverse();
    },
  },
  methods: {
    loadWords(){
      var newUrl = urlAPIGet+""+(this.limitMessages+4); 
      console.log(newUrl);
      fetch(newUrl).then(res => res.json()).then((result) => {
        this.messages = result;
        console.log(result);
      });
    },
    show() {
      this.$modal.show('welcome');
    },
    showAPIDoc() {
      this.$modal.show('apiModal');
    },
    showAbout() {
      this.$modal.show('aboutModal');
    },
    showMsgModal(msgNumber) {
      this.$modal.show('msgModal');
      var urlGetWords = 'https://young-brook-59453.herokuapp.com/specific-words/'+msgNumber;
      console.log(urlGetWords);
      fetch(urlGetWords).then(res => res.json()).then((result) => {
          console.log(result);
          this.getMessage = result;
      });
    },
    addMessage() {
      this.message.number = this.messages.length;
      console.log(this.messages.length);
      fetch(urlAPIPost, {
        method: 'POST',
        body: JSON.stringify(this.message),
        headers: { 'content-type': 'application/json' },
      }).then(res => res.json()).then((result) => {
        if (result.details) {
          const err = result.details.map(det => det.message).join(' ');
          this.error = err;
        } else {
          this.error = '';
          this.messages.push(result);
          this.message.message = '';
        }
      });
    },
  },
};
</script>
